import React, { forwardRef, useRef, useImperativeHandle } from "react";

import { a, SpringConfig } from "@react-spring/web";

import { useIntersect } from "hooks/useIntersect";
import { useAnimateInSpring, IAnimateInProps } from "hooks/useAnimateInSpring";
import {
  initialOffset,
  defaultSpringConfig,
} from "components/Animations/SpringProperties/SpringProperties";

import { LazyVideo, LazyVideoProps } from "components/Video";

type IOwnProps = LazyVideoProps & IAnimateInProps;

type IProps = IOwnProps;

const ViewportVideoComponent: React.FC<IProps> = ({
  animationReady,
  height,
  width,
  heightRatio,
  url,
  placeholderSrc,
  placeholderBackgroundColor,
  playVideo,
  loop,
  autoPlay,
  muted,
  animationType,
}) => {
  const [inViewRef, inView] = useIntersect({
    startObserving: animationReady,
  });

  const springConfig: SpringConfig = {
    ...defaultSpringConfig,
    tension: 85,
    friction: 29,
  };
  const animateInSpring = useAnimateInSpring(inView, springConfig);

  const containerStyles = {
    opacity: animateInSpring.active,
    transform: animateInSpring.active.to(
      (x) => `translateY(calc(${initialOffset(x)}))`
    ),
  };

  return (
    <a.div ref={inViewRef} style={containerStyles}>
      <LazyVideo
        width={width}
        height={height}
        heightRatio={heightRatio}
        url={url}
        placeholderSrc={placeholderSrc}
        placeholderBackgroundColor={placeholderBackgroundColor}
        playVideo={playVideo}
        loop={loop}
        autoPlay={autoPlay}
        muted={muted}
        animateVideoIn={inView}
        animationType={animationType}
      />
    </a.div>
  );
};

export const ViewportVideo = ViewportVideoComponent;
